'use client';

import { tsrClient } from '@/libs/ts-rest/ts-client';
import { createGetGuestCartQueryOptions, createGetMemberCartQueryOptions } from '../../react-query';
import { useAuthStore } from '@/modules/auth';

const useGetCartQuery = (promotionId?: string | null | undefined) => {
	const { isPending, checkIsAuthenticate } = useAuthStore();
	const isAuthenticate = checkIsAuthenticate();

	const cartQueryResult = isAuthenticate
		? tsrClient.web.cart.get.useQuery(createGetMemberCartQueryOptions(!isPending(), promotionId))
		: tsrClient.web.guestCart.get.useQuery(createGetGuestCartQueryOptions(!isPending()));

	return cartQueryResult;
};

export default useGetCartQuery;